import { jsx as L, jsxs as t } from "react/jsx-runtime";
import "react";
var h = (l) => /* @__PURE__ */ t("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...l,
  children: [
    /* @__PURE__ */ L("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ L("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-320 -952)",
      fill: "white"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 5.65173H0V14.3478H20V5.65173Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ L("path", {
      d: "M16.5218 11.7491L16.0511 12.1169L16.2554 12.678L15.7602 12.3441L15.2895 12.7118L15.4541 12.1377L14.959 11.8036L15.5559 11.7828L15.7205 11.2087L15.9249 11.77L16.5218 11.7491Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M15.3171 9.66176L15.0006 10.1683L15.3845 10.6257L14.805 10.4814L14.4885 10.9878L14.4467 10.392L13.8672 10.2475L14.4211 10.0238L14.3795 9.42786L14.7634 9.88547L15.3171 9.66176Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M13.4706 8.11243L13.3465 8.69665L13.8637 8.99532L13.2697 9.0579L13.1455 9.642L12.9026 9.09645L12.3086 9.15879L12.7525 8.75907L12.5095 8.21352L13.0268 8.51211L13.4706 8.11243Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M11.2045 7.28809L11.2877 7.87957L11.8759 7.98324L11.3391 8.24516L11.4222 8.83664L11.0073 8.40695L10.4704 8.66879L10.7509 8.14141L10.3359 7.71184L10.9242 7.81547L11.2045 7.28809Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M8.79437 7.28809L9.07484 7.81547L9.66293 7.71168L9.24809 8.14148L9.52844 8.66887L8.99168 8.40695L8.57672 8.83652L8.65992 8.24516L8.12305 7.9834L8.71129 7.87957L8.79437 7.28809Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M6.52973 8.11243L6.97367 8.51211L7.49078 8.21352L7.24797 8.75926L7.69176 9.15887L7.09781 9.09645L6.85477 9.642L6.73074 9.05778L6.13672 8.99543L6.65398 8.69672L6.52973 8.11243Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M4.68258 9.66173L5.23648 9.88544L5.62027 9.42798L5.57875 10.0239L6.13246 10.2476L5.55293 10.3921L5.51121 10.9878L5.1948 10.4814L4.61523 10.6258L4.99918 10.1683L4.68258 9.66173Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M3.47852 11.7491L4.07559 11.77L4.27977 11.2087L4.44457 11.7829L5.04141 11.8038L4.54621 12.1378L4.71082 12.7119L4.24023 12.3442L3.74504 12.6781L3.94934 12.1168L3.47852 11.7491Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ L("path", {
      d: "M20 0H0V5.65176H20V0Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  h as default
};
